/* Rolvea — Compositore Sculptline (v2).

   NIENTE PASSI. Si atterra su sei set gia' composti, se ne apre uno e lo si
   smonta riga per riga. Indietro/avanti sono i tasti del browser, perche' lo
   stato sta nell'URL. Non esiste un "Ricomincia" perche' non c'e' niente da
   ricominciare.

   Il conto del 2+1 e' l'unica cosa ereditata dalla v1: ogni 3 unita' del pool
   `collezione-completa` Shopify azzera la PIU' ECONOMICA, senza limite per
   ordine. Il totale in pagina e' pero' una PREVISIONE: dopo l'aggiunta si
   rilegge /cart.js e se diverge si corregge in pagina invece di mentire.

   La taglia e' calcolata PER CAPO, non per set: un leggings Edge ha 2 cm di
   fianchi in meno del Classic a ogni taglia, quindi "una taglia per tutto il
   set" e' una promessa che i dati non reggono. Se il modulo taglie non c'e' o
   non sa rispondere, si dice e restano le misure in cm: mai un numero di
   ripiego con la faccia della precisione. */
(function () {
  'use strict';

  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL'];
  var PROFILE_KEY = 'rlv_size_profile_v6';
  var STATE_KEY = 'rlv_comp_state_v1';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function img(url, w) {
    return url ? url.replace(/([?&])width=\d+/, '$1width=' + w) : '';
  }
  function routeRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function track(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, data || {}));
      if (window.gtag) window.gtag('event', name, data || {});
      if (window.fbq) window.fbq('trackCustom', name, data || {});
    } catch (e) { /* il tracciamento non deve mai rompere la pagina */ }
  }

  function init(node) {
    if (node.dataset.rlvInit) return;
    node.dataset.rlvInit = '1';

    var raw = node.querySelector('[data-rlv-data]');
    if (!raw) return;
    var CFG;
    try { CFG = JSON.parse(raw.textContent); } catch (e) { return; }

    var T = CFG.t || {};
    var SETS = CFG.sets || [];
    var POOLS = CFG.pools || [];
    var OFFER = CFG.offer || { active: false, everyN: 3 };
    var FMT = CFG.moneyFormat || '€{{amount_with_comma_separator}}';

    /* ---------- soldi: separatori e simbolo li decide il mercato ---------- */
    function money(cents) {
      var v = cents / 100;
      function grp(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
      return FMT.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, tok) {
        var d = v.toFixed(2), i = d.split('.')[0], dec = d.split('.')[1];
        switch (tok) {
          case 'amount_no_decimals': return grp(String(Math.round(v)), ',');
          case 'amount_with_comma_separator': return grp(i, '.') + ',' + dec;
          case 'amount_no_decimals_with_comma_separator': return grp(String(Math.round(v)), '.');
          case 'amount_with_apostrophe_separator': return grp(i, "'") + '.' + dec;
          default: return grp(i, ',') + '.' + dec;
        }
      });
    }

    /* ---------- stato ---------- */
    var S = { setId: null, rows: [], pools: {}, sheet: null };
    var $ = function (s) { return node.querySelector(s); };

    /* ---------- taglia ----------
       Si tenta la matrice del modulo taglie del tema, che e' l'unica fonte
       che conosce le tre serie. Se manca o non e' leggibile si ripiega sul
       profilo salvato, e se manca anche quello non si stampa nessuna taglia. */
    function profile() {
      try { return JSON.parse(localStorage.getItem(PROFILE_KEY) || 'null'); }
      catch (e) { return null; }
    }
    function nearest(arr, v) {
      var bi = 0, bd = Infinity;
      for (var i = 0; i < arr.length; i++) {
        var d = Math.abs(arr[i] - v);
        if (d < bd) { bd = d; bi = i; }
      }
      return bi;
    }
    function matrixSize(serie, h, w) {
      var A = window.RolveaSizeAdvisor;
      if (!A || !A.MATRIX || !A.H_ROWS || !A.W_COLS) return null;
      var M = A.MATRIX[serie] || A.MATRIX['3003'];
      if (!M || !M.length) return null;
      var row = M[nearest(A.H_ROWS, h)];
      if (!row) return null;
      var val = Array.isArray(row) ? row[nearest(A.W_COLS, w)] : null;
      if (typeof val === 'string') return val;
      if (val && typeof val === 'object') return val.size || val.s || null;
      return null;
    }
    /* La taglia proposta deve ESISTERE in questo prodotto: 8022 Costa non ha
       la XS, e proporla per poi rifiutarla in cassa e' il gesto piu' costoso. */
    function sizesOf(p) { return (p.v || []).map(function (v) { return v[1]; }); }
    function availOf(p) { return (p.v || []).filter(function (v) { return v[2]; }).map(function (v) { return v[1]; }); }
    function recoFor(p) {
      var pr = profile();
      if (!pr || !(pr.h > 0 && pr.w > 0)) return null;
      var s = matrixSize(p.s, pr.h, pr.w) || pr.reco || null;
      if (!s) return null;
      var av = availOf(p);
      if (av.indexOf(s) >= 0) return { size: s, exact: true };
      /* esiste la taglia ma non in questo capo: si sale alla piu' vicina
         disponibile e si dice perche', invece di tacere */
      var want = SIZE_ORDER.indexOf(s), best = null, bd = 99;
      av.forEach(function (x) {
        var d = Math.abs(SIZE_ORDER.indexOf(x) - want);
        if (d < bd) { bd = d; best = x; }
      });
      return best ? { size: best, exact: false, wanted: s } : null;
    }

    /* ---------- prezzo: lo stesso conto che fa la cassa ---------- */
    function priced() {
      var rows = S.rows.filter(function (r) { return r && r.p; });
      var prices = rows.map(function (r) { return r.p.p; }).sort(function (a, b) { return a - b; });
      var n = prices.length;
      var total = prices.reduce(function (a, b) { return a + b; }, 0);
      var freeN = OFFER.active ? Math.floor(n / (OFFER.everyN || 3)) : 0;
      var freed = prices.slice(0, freeN).reduce(function (a, b) { return a + b; }, 0);
      return { n: n, total: total, freeN: freeN, freed: freed, pay: total - freed, ceiling: freeN ? prices[freeN - 1] : -1 };
    }

    /* ---------- scaffale ---------- */
    function renderShelf() {
      var wrap = $('[data-rlv-shelf]');
      wrap.innerHTML = '';
      SETS.forEach(function (st) {
        var live = st.rows.filter(Boolean);
        if (live.length < 2) return; /* mai un buco nella striscia */
        var sum = live.reduce(function (a, p) { return a + p.p; }, 0);
        var freeN = OFFER.active ? Math.floor(live.length / (OFFER.everyN || 3)) : 0;
        var cheap = live.map(function (p) { return p.p; }).sort(function (a, b) { return a - b; });
        var pay = sum - cheap.slice(0, freeN).reduce(function (a, b) { return a + b; }, 0);

        var card = el('div', 'rlv__set');
        var strip = el('div', 'rlv__strip');
        live.forEach(function (p) {
          strip.innerHTML += '<img src="' + esc(img(p.i, 400)) + '" alt="' + esc(p.t + ' ' + p.cn) + '" loading="lazy">';
        });
        card.appendChild(strip);

        var body = el('div', 'rlv__setb');
        body.appendChild(el('div', 'rlv__setn', esc(st.title || (live[0].ll + ' · ' + live[0].cn))));
        body.appendChild(el('div', 'rlv__facts', esc(live.map(function (p) { return p.t; }).join(' + '))));
        var pr = el('div', 'rlv__setp');
        pr.innerHTML = (pay < sum ? '<s>' + money(sum) + '</s>' : '') + '<b>' + money(pay) + '</b>';
        body.appendChild(pr);
        var btn = el('button', 'rlv__cta', esc(T.openSet || 'Apri e personalizza'));
        btn.type = 'button';
        btn.addEventListener('click', function () { openSet(st.id, 'shelf'); });
        body.appendChild(btn);
        card.appendChild(body);
        wrap.appendChild(card);
      });
    }

    /* ---------- apertura di un set ---------- */
    function openSet(id, source) {
      var st = SETS.filter(function (x) { return x.id === id; })[0];
      if (!st) return;
      S.setId = id;
      S.rows = st.rows.filter(Boolean).map(function (p) {
        var r = recoFor(p);
        return { p: p, size: r ? r.size : null, reco: r };
      });
      track('rlv_comp_set_open', { setId: id, source: source || 'shelf' });
      renderRows();
      pushState();
      var t = $('[data-rlv-rows]');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* ---------- righe capo ---------- */
    function renderRows() {
      var box = $('[data-rlv-rows]');
      var why = $('[data-rlv-why2]');
      box.innerHTML = '';
      if (!S.rows.length) { box.hidden = true; why.hidden = true; renderBar(); return; }
      box.hidden = false;

      var st = SETS.filter(function (x) { return x.id === S.setId; })[0];
      if (st && st.why) { why.hidden = false; why.textContent = st.why; } else { why.hidden = true; }

      var pz = priced();
      var marked = 0;

      S.rows.forEach(function (r, idx) {
        var p = r.p;
        var isFree = pz.freeN > 0 && marked < pz.freeN && p.p <= pz.ceiling;
        if (isFree) marked++;
        var row = el('div', 'rlv__row' + (r.size ? '' : ' is-todo'));
        row.dataset.idx = String(idx);

        if (r.size) {
          /* STATO B: confermata e collassata, la pagina si accorcia */
          var mini = el('div', 'rlv__mini');
          mini.innerHTML =
            '<img src="' + esc(img(p.i, 200)) + '" alt="" loading="lazy">' +
            '<span class="rlv__minit"><b>' + esc(p.t + ' ' + p.ll + ' · ' + p.cn) + '</b>' +
            '<span>' + esc(T.size || 'Taglia') + ' ' + esc(r.size) + ' · ' +
            (isFree ? '<span class="rlv__free">' + esc(T.free || 'in regalo') + '</span>' : money(p.p)) +
            '</span></span>';
          var edit = el('button', 'rlv__tx', esc(T.edit || 'Modifica'));
          edit.type = 'button';
          edit.addEventListener('click', function () { r.size = null; renderRows(); });
          mini.appendChild(edit);
          row.appendChild(mini);
        } else {
          row.appendChild(openRow(r, idx, isFree));
        }
        box.appendChild(row);
      });

      renderGiftBox();
      renderBar();
      saveState();
    }

    function openRow(r, idx, isFree) {
      var p = r.p;
      var o = el('div', 'rlv__open');
      o.appendChild(el('div', 'rlv__role', esc(roleLabel(p.r))));
      if (!r.size) o.appendChild(el('div', 'rlv__todo', esc(T.pickSize || 'Scegli la taglia per continuare')));

      var prod = el('div', 'rlv__prod');
      prod.innerHTML = p.i ? '<img src="' + esc(img(p.i, 400)) + '" alt="' + esc(p.cn) + '" loading="eager" decoding="async">' : '';
      var pb = el('div', 'rlv__pb');
      pb.appendChild(el('div', 'rlv__pn', esc(p.t + ' · ' + p.cn)));
      pb.appendChild(el('span', 'rlv__badge', esc(p.ll)));
      var pp = el('div', 'rlv__pp');
      pp.innerHTML = (p.cp && p.cp > p.p ? '<s>' + money(p.cp) + '</s>' : '') +
        (isFree ? '<span class="rlv__free">' + esc(T.free || 'in regalo') + '</span>' : money(p.p));
      pb.appendChild(pp);

      /* taglie: disponibile / esaurita / inesistente sono tre cose diverse */
      var sz = el('div', 'rlv__sz');
      (p.v || []).forEach(function (v) {
        var b = el('button', 'rlv__szb' + (r.size === v[1] ? ' is-on' : '') +
          (r.reco && r.reco.size === v[1] ? ' is-reco' : ''), esc(v[1]));
        b.type = 'button';
        if (!v[2]) { b.disabled = true; b.title = T.soldout || 'Esaurita'; b.setAttribute('aria-label', v[1] + ' — ' + (T.soldout || 'esaurita')); }
        b.addEventListener('click', function () {
          r.size = v[1];
          track('rlv_comp_size_pick', { role: p.r, handle: p.h, size: v[1], reco: r.reco ? r.reco.size : null });
          renderRows();
        });
        sz.appendChild(b);
      });
      pb.appendChild(sz);

      if (r.reco && !r.reco.exact) {
        pb.appendChild(el('div', 'rlv__note rlv__note--warn',
          esc((T.noSize || 'In questa linea la {w} non esiste: la piu vicina e la {s}.')
            .replace('{w}', r.reco.wanted).replace('{s}', r.reco.size))));
      } else if (r.reco) {
        pb.appendChild(el('div', 'rlv__note', esc((T.recoNote || 'Stima su altezza e peso: {s}.').replace('{s}', r.reco.size))));
      } else {
        var ask = el('button', 'rlv__tx', esc(T.findSize || 'Non so la mia taglia'));
        ask.type = 'button';
        ask.addEventListener('click', openSizePanel);
        pb.appendChild(ask);
      }
      prod.appendChild(pb);
      o.appendChild(prod);

      /* misure in cm: in pagina, mai in popup */
      var meas = el('div', 'rlv__meas');
      meas.hidden = true;
      o.appendChild(meas);

      var acts = el('div', 'rlv__acts');
      acts.appendChild(txt(T.measures || 'Misure in cm', function () {
        if (meas.hidden) { meas.innerHTML = measuresHTML(p, r.size); meas.hidden = false; track('rlv_comp_measures_open', { handle: p.h }); }
        else meas.hidden = true;
      }));
      acts.appendChild(txt(T.otherColor || 'Altro colore', function () { openTiles(idx, 'color'); }));
      acts.appendChild(txt(T.otherGarment || 'Cambia capo', function () { openTiles(idx, 'swap'); }));
      var link = el('a', 'rlv__tx', esc(T.seePdp || 'Vedi la scheda'));
      link.href = routeRoot() + 'products/' + p.h;
      link.target = '_blank';
      link.rel = 'noopener';
      acts.appendChild(link);
      o.appendChild(acts);
      return o;
    }

    function txt(label, fn) {
      var b = el('button', 'rlv__tx', esc(label));
      b.type = 'button';
      b.addEventListener('click', fn);
      return b;
    }
    function roleLabel(r) {
      return r === 'sotto' ? (T.roleBottom || 'SOTTO') : r === 'intero' ? (T.roleFull || 'INTERO') : (T.roleTop || 'SOPRA');
    }

    /* ---------- misure dal metafield, mai riscritte a mano ---------- */
    function measuresHTML(p, chosen) {
      if (!p.m) return '<p class="rlv__cap">' + esc(T.noMeasures || 'Misure non disponibili.') + '</p>';
      var lines = p.m.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
      if (lines.length < 2) return '<p class="rlv__cap">' + esc(T.noMeasures || 'Misure non disponibili.') + '</p>';
      var head = lines[0].split('|').map(function (c) { return c.trim(); });
      var body = lines.slice(1).map(function (l) { return l.split('|').map(function (c) { return c.trim(); }); });
      var sizeCol = head.indexOf('Taglia') >= 0 ? head.indexOf('Taglia') : 0;
      var h = '<div class="rlv__scroll"><table><thead><tr>';
      head.forEach(function (c) { h += '<th>' + esc(c) + '</th>'; });
      h += '</tr></thead><tbody>';
      body.forEach(function (cells) {
        var you = chosen && cells[sizeCol] === chosen;
        h += '<tr class="' + (you ? 'is-you' : '') + '">';
        cells.forEach(function (c, i) { h += (i === 0 ? '<th>' : '<td>') + esc(c) + (i === 0 ? '</th>' : '</td>'); });
        h += '</tr>';
      });
      h += '</tbody></table></div>';
      if (T.measCap) h += '<p class="rlv__cap">' + esc(T.measCap) + '</p>';
      return h;
    }

    /* ---------- pool via Section Rendering API ---------- */
    function fetchPool(handle) {
      if (S.pools[handle]) return Promise.resolve(S.pools[handle]);
      return fetch(routeRoot() + 'collections/' + handle + '?section_id=rlv-pool')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var t = html.indexOf('{'), e = html.lastIndexOf('}');
          var data = JSON.parse(html.slice(t, e + 1));
          S.pools[handle] = data.products || [];
          return S.pools[handle];
        })
        .catch(function () { S.pools[handle] = []; return []; });
    }

    /* ---------- foglio tessere (colore / cambia capo / catalogo) ---------- */
    function openTiles(idx, mode) {
      var r = S.rows[idx];
      var sheet = $('[data-rlv-sheet]');
      var title = $('[data-rlv-stitle]');
      var body = $('[data-rlv-sbody]');
      var handles;

      if (mode === 'color' && r) {
        title.textContent = T.otherColor || 'Altro colore';
        handles = ['gruppo-' + r.p.g.toLowerCase()];
      } else if (mode === 'swap' && r) {
        title.textContent = T.otherGarment || 'Cambia capo';
        handles = POOLS.filter(function (x) { return x.r === r.p.r; }).map(function (x) { return x.h; });
      } else {
        title.textContent = T.allModels || 'Tutti i modelli';
        handles = POOLS.map(function (x) { return x.h; });
      }

      sheet.classList.add('is-on');
      body.innerHTML = '<p class="rlv__load">' + esc(T.loading || 'Carico…') + '</p>';
      track(mode === 'catalog' ? 'rlv_comp_catalog_open' : 'rlv_comp_swap_open', { mode: mode, role: r ? r.p.r : null });

      var famWanted = r ? r.p.f : null;
      Promise.all(handles.map(fetchPool)).then(function (lists) {
        var all = [];
        lists.forEach(function (l) { all = all.concat(l); });
        renderTiles(body, all, idx, mode, famWanted);
      });
    }

    function renderTiles(body, all, idx, mode, famWanted) {
      body.innerHTML = '';
      var state = { fam: mode === 'color' ? null : famWanted, onlyMine: false };
      var pr = profile();

      var chips = el('div', 'rlv__chips');
      if (mode !== 'color' && famWanted) {
        var c1 = el('button', 'rlv__chip is-on', esc((T.matchColor || 'Abbina il colore: {f}').replace('{f}', famWanted)));
        c1.type = 'button';
        c1.addEventListener('click', function () {
          state.fam = state.fam ? null : famWanted;
          c1.classList.toggle('is-on', !!state.fam);
          paint();
        });
        chips.appendChild(c1);
      }
      if (pr && pr.reco) {
        var c2 = el('button', 'rlv__chip', esc((T.onlyMine || 'Solo nella mia taglia ({s})').replace('{s}', pr.reco)));
        c2.type = 'button';
        c2.addEventListener('click', function () {
          state.onlyMine = !state.onlyMine;
          c2.classList.toggle('is-on', state.onlyMine);
          paint();
        });
        chips.appendChild(c2);
      }
      if (chips.children.length) body.appendChild(chips);

      var note = el('p', 'rlv__sortnote', '');
      body.appendChild(note);
      var grid = el('div', 'rlv__tiles');
      body.appendChild(grid);

      function paint() {
        var list = all.slice();
        if (state.fam) list = list.filter(function (p) { return p.f === state.fam; });
        /* i capi fuori taglia scendono in fondo COL MOTIVO, non spariscono */
        var pr2 = profile();
        if (pr2 && pr2.reco) {
          list.sort(function (a, b) {
            var aa = availOf(a).indexOf(pr2.reco) >= 0 ? 0 : 1;
            var bb = availOf(b).indexOf(pr2.reco) >= 0 ? 0 : 1;
            return aa - bb;
          });
          if (state.onlyMine) list = list.filter(function (p) { return availOf(p).indexOf(pr2.reco) >= 0; });
        }
        note.textContent = state.fam
          ? (T.sortFam || 'In ordine: prima i capi in {f}.').replace('{f}', state.fam)
          : (T.sortAll || 'In ordine di catalogo.');
        grid.innerHTML = '';
        if (!list.length) { grid.innerHTML = '<p class="rlv__load">' + esc(T.empty || 'Nessun capo con questi filtri.') + '</p>'; return; }
        list.forEach(function (p) {
          var cur = S.rows[idx] && S.rows[idx].p.h === p.h;
          var mine = !pr2 || !pr2.reco || availOf(p).indexOf(pr2.reco) >= 0;
          var b = el('button', 'rlv__tile' + (cur ? ' is-on' : '') + (mine ? '' : ' is-off'));
          b.type = 'button';
          b.innerHTML = '<img src="' + esc(img(p.i, 300)) + '" alt="' + esc(p.cn) + '" loading="lazy">' +
            '<span class="rlv__tn"' + (mine ? '' : ' data-why="' + esc((T.noYourSize || 'niente {s}').replace('{s}', pr2.reco)) + '"') + '>' +
            esc(mode === 'color' ? p.cn : p.t + ' · ' + p.cn) + '</span>' +
            '<span class="rlv__tp">' + money(p.p) + '</span>';
          b.addEventListener('click', function () {
            var row = S.rows[idx];
            if (!row) { closeSheet(); return; }
            var was = row.p.h;
            row.p = p;
            var rc = recoFor(p);
            row.reco = rc;
            row.size = rc && rc.exact ? rc.size : null;
            track('rlv_comp_row_changed', { mode: mode, from: was, to: p.h });
            closeSheet();
            renderRows();
            pushState();
          });
          grid.appendChild(b);
        });
      }
      paint();
    }

    function closeSheet() { $('[data-rlv-sheet]').classList.remove('is-on'); }

    /* ---------- pannello taglia: UNA sola istanza dell'advisor ---------- */
    function openSizePanel() {
      var host = node.querySelector('[data-rsa] button, [data-rsa] a');
      track('rlv_comp_size_panel_open', {});
      if (host) {
        var holder = node.querySelector('[data-rlv-advisor]');
        if (holder) holder.style.display = '';
        host.click();
        /* alla chiusura il profilo e' su localStorage: si ricalcola per capo */
        var iv = setInterval(function () {
          var p = profile();
          if (p && p.reco) {
            clearInterval(iv);
            if (holder) holder.style.display = 'none';
            S.rows.forEach(function (r) {
              var rc = recoFor(r.p);
              r.reco = rc;
              if (rc && rc.exact && !r.size) r.size = rc.size;
            });
            track('rlv_comp_size_computed', { sizes: S.rows.map(function (r) { return r.size; }).join(',') });
            renderRows();
          }
        }, 600);
        setTimeout(function () { clearInterval(iv); }, 90000);
      } else {
        /* degradazione dichiarata: niente numero inventato, restano le misure */
        var first = node.querySelector('[data-idx] .rlv__acts .rlv__tx');
        if (first) first.click();
      }
    }

    /* ---------- riquadro regalo, scala per intero ---------- */
    function renderGiftBox() {
      var box = $('[data-rlv-gift]');
      if (!OFFER.active || !S.rows.length) { box.hidden = true; return; }
      var pz = priced();
      var everyN = OFFER.everyN || 3;
      var need = everyN - (pz.n % everyN);
      box.hidden = false;
      box.innerHTML = pz.freeN > 0
        ? '<b>' + esc((T.giftOn || 'Il meno caro dei {n} e in regalo.').replace('{n}', String(everyN))) + '</b> ' +
          esc(T.giftLadder || '')
        : esc((T.giftNeed || 'Aggiungi ancora {k}.')
            .replace('{k}', String(need)).replace('{n}', String(everyN)));
    }

    /* ---------- barra ---------- */
    function renderBar() {
      var bar = $('[data-rlv-bar]');
      var pz = priced();
      bar.hidden = false;

      var slots = $('[data-rlv-slots]');
      slots.innerHTML = '';
      var target = Math.max(OFFER.everyN || 3, S.rows.length);
      for (var i = 0; i < target; i++) {
        var r = S.rows[i];
        var b = el('button', 'rlv__slot' + (r ? ' is-full' : ''));
        b.type = 'button';
        b.innerHTML = r
          ? '<img src="' + esc(img(r.p.i, 120)) + '" alt="">'
          : '<i>' + esc(i === 0 ? roleLabel('sopra') : i === 1 ? roleLabel('sotto') : (T.roleThird || '3')) + '</i>';
        (function (k) {
          b.addEventListener('click', function () {
            if (S.rows[k]) { S.rows[k].size = null; renderRows(); }
            var box = $('[data-rlv-rows]');
            if (box && !box.hidden) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
            else $('[data-rlv-shelf]').scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        })(i);
        slots.appendChild(b);
      }

      var m = $('[data-rlv-money]');
      m.innerHTML = pz.n
        ? '<b>' + (pz.freed ? '<s>' + money(pz.total) + '</s>' : '') + money(pz.pay) + '</b>' +
          '<span class="' + (pz.freeN ? '' : 'rlv__plain') + '">' +
          esc(pz.n + ' ' + (pz.n === 1 ? (T.piece || 'capo') : (T.pieces || 'capi'))) + '</span>'
        : '<b>—</b><span class="rlv__plain">' + esc(T.barEmpty || '') + '</span>';

      var add = $('[data-rlv-add]');
      var missing = S.rows.filter(function (r) { return !r.size; })[0];
      add.classList.toggle('is-todo', !!missing || !pz.n);
      add.disabled = false;
      if (!pz.n) {
        add.textContent = T.barStart || 'Scegli un set';
        add.onclick = function () { $('[data-rlv-shelf]').scrollIntoView({ behavior: 'smooth', block: 'start' }); };
      } else if (missing) {
        add.textContent = (T.barMissing || 'Manca la taglia: {t}').replace('{t}', missing.p.t);
        add.onclick = function () {
          var i = S.rows.indexOf(missing);
          var target2 = node.querySelector('[data-idx="' + i + '"]');
          if (target2) target2.scrollIntoView({ behavior: 'smooth', block: 'center' });
        };
      } else {
        add.textContent = (T.barAdd || 'Aggiungi {n} — {p}').replace('{n}', String(pz.n)).replace('{p}', money(pz.pay));
        add.onclick = addToCart;
      }
    }

    /* ---------- carrello, con riconciliazione ---------- */
    function addToCart() {
      var items = [];
      var ok = true;
      S.rows.forEach(function (r) {
        var v = (r.p.v || []).filter(function (x) { return x[1] === r.size; })[0];
        if (v && v[2]) items.push({ id: v[0], quantity: 1 }); else ok = false;
      });
      if (!ok || !items.length) { renderRows(); return; }

      var add = $('[data-rlv-add]');
      var predicted = priced().pay;
      add.disabled = true;
      add.textContent = T.adding || 'Aggiungo…';

      fetch(routeRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return fetch(routeRoot() + 'cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          track('rlv_comp_add_to_cart', { pieces: items.length, predicted: predicted, actual: cart.total_price });
          if (Math.abs(cart.total_price - predicted) <= 1) {
            window.location.href = routeRoot() + 'cart';
            return;
          }
          /* il totale in pagina era una previsione: si corregge, non si mente */
          track('rlv_comp_cart_mismatch', { predicted: predicted, actual: cart.total_price });
          var mm = $('[data-rlv-mismatch]');
          mm.hidden = false;
          mm.textContent = (T.mismatch || '').replace('{a}', money(cart.total_price)).replace('{p}', money(predicted));
          add.disabled = false;
          add.textContent = (T.goCart || 'Vai al carrello — {p}').replace('{p}', money(cart.total_price));
          add.onclick = function () { window.location.href = routeRoot() + 'cart'; };
        })
        .catch(function () {
          add.disabled = false;
          renderBar();
          var mm = $('[data-rlv-mismatch]');
          mm.hidden = false;
          mm.textContent = T.err || 'Errore, riprova.';
        });
    }

    /* ---------- stato in URL: il tasto indietro annulla ---------- */
    function encode() {
      if (!S.rows.length) return '';
      return S.rows.map(function (r) { return r.p.h + ':' + (r.size || ''); }).join(',');
    }
    function pushState() {
      try {
        var u = new URL(window.location.href);
        var v = encode();
        if (v) u.searchParams.set('set', v); else u.searchParams.delete('set');
        history.pushState({ rlv: v }, '', u.toString());
      } catch (e) { /* non bloccare mai la pagina per la cronologia */ }
    }
    function saveState() {
      try { sessionStorage.setItem(STATE_KEY, encode()); } catch (e) { }
    }
    function restore(v) {
      if (!v) { S.rows = []; S.setId = null; renderRows(); return; }
      var parts = v.split(',').map(function (x) { return x.split(':'); });
      var known = {};
      SETS.forEach(function (st) { st.rows.filter(Boolean).forEach(function (p) { known[p.h] = p; }); });
      var need = parts.filter(function (x) { return !known[x[0]]; });
      if (!need.length) { applyRestore(parts, known); return; }
      /* i capi non in vetrina si ripescano dai pool, senza inventare nulla */
      Promise.all(POOLS.map(function (x) { return fetchPool(x.h); })).then(function (lists) {
        lists.forEach(function (l) { l.forEach(function (p) { known[p.h] = p; }); });
        applyRestore(parts, known);
      });
    }
    function applyRestore(parts, known) {
      S.rows = parts.map(function (x) {
        var p = known[x[0]];
        if (!p) return null;
        return { p: p, size: x[1] || null, reco: recoFor(p) };
      }).filter(Boolean);
      renderRows();
    }

    window.addEventListener('popstate', function (e) {
      var v = (e.state && e.state.rlv) || '';
      if (!v) { try { v = new URL(window.location.href).searchParams.get('set') || ''; } catch (err) { } }
      restore(v);
    });

    /* ---------- avvio ---------- */
    renderShelf();
    Array.prototype.forEach.call(node.querySelectorAll('[data-rlv-close]'), function (b) { b.addEventListener('click', closeSheet); });
    var catalogBtn = $('[data-rlv-catalog]');
    if (catalogBtn) catalogBtn.addEventListener('click', function () { openTiles(-1, 'catalog'); });

    var initial = '';
    try { initial = new URL(window.location.href).searchParams.get('set') || sessionStorage.getItem(STATE_KEY) || ''; } catch (e) { }
    if (initial) restore(initial); else renderBar();
    track('rlv_comp_view', { sets: SETS.length, offerActive: !!OFFER.active });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rlv]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
